import { k } from "../kaplay";

import { properties } from "../data/properties";
import { addSpike } from "../gameobjects/spike";

export function spikes(){
  return {
    id: "spikes",
    spawning: false,
    setSpikeNumber(number){
      properties.spike.number = number;
      k.get("spike").forEach((s) => s.destroy());
      this.createSpikes();
    },
    createSpikes(){
      for(let i = 0; i < properties.spike.number; i++){
        addSpike();
      }
    },
    update() {
      if (!this.spawning){
        this.spawning = true;

        k.wait(properties.spike.spawnSpeed, () => {
          this.spawning = false;
          this.createSpikes();
        })
      }
    },
    destroy(){
      k.get("spike").forEach((s) => s.destroy());
    }
  }
}